module.exports = __webpack_public_path__ + "media/application/images/hambergermenu-0c0ddccbf93ebfcc1d3c50995c6ccbc4.svg";